import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';

import { newValue, newRate } from '@tool/index';

const moUpRate = observable({
  type: 'chart', // chart, table
  xData: <any[]>[],
  yData: <any[]>[],
  tableLeft: <any[]>[],
  tableRight: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
});

const initUpRate = action((res: any) => {
  // console.log('行业涨薪率 -- ', res);
  const { type } = moUpRate;

  const tempType = localStorage.getItem('indicatorType1') || '';
  if (tempType && (tempType !== type)) moUpRate.type = tempType;
  else localStorage.setItem('indicatorType1', type);

  if (isEmpty(res)) return;

  const xData: any[] = [];
  const yData: any[] = [];
  const tableLeft: any[] = [];
  let tableRight: any[] = [];
  const years: any[] = [];
  const series: any[] = [];
  const overview: any[] = [];

  res.data?.map((item: any) => {
    xData.push(item.industry);
    series.push(item.year_data);
    tableLeft.push(item.industry);
  });
  tableLeft.unshift('行业');

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });
  // console.log('overview -- ', overview);

  series.map((item: any) => {
    item?.map((child: any) => {
      years.push(child.date);
    });
  });
  uniq(years).map((year: any) => {
    let temp: any[] = [];
    series.map((item: any) => {
      item?.map((child: any) => {
        if (child.date === year) temp.push(child.change_rate);
      });
    });
    yData.push({
      name: year,
      data: temp,
    });
  });
  // console.log('yData -- ', yData);

  tableRight.push(uniq(years));
  res.data?.map((item: any) => {
    let temp: any[]= [];
    item.year_data?.map((child: any) => {
      temp.push(newRate(child.change_rate, 1));
    });
    tableRight.push(temp);
  });
  // console.log('table right -- ', tableRight);

  moUpRate.xData = xData;
  moUpRate.yData = yData;
  moUpRate.overview = overview;
  moUpRate.tableLeft = tableLeft;
  moUpRate.tableRight = tableRight;
  moUpRate.labels = res.total_industry_data || [];
});

const changeType = action((type: string) => {
  moUpRate.type = type;
  localStorage.setItem('indicatorType1', type);
});

export default moUpRate;
export { initUpRate, changeType };
